<template>
  <PrivacySection title="1. Introduzione">
    <p>
      La presente Informativa sulla Privacy ("Privacy Policy") descrive come ISIGest S.r.l. 
      ("noi", "nostro", "ci") raccoglie, utilizza, conserva e protegge le informazioni 
      personali degli utenti che utilizzano il nostro sito web (www.appscontrini.it) e 
      l'applicazione mobile "App degli Scontrini" (di seguito, collettivamente, i "Servizi").
    </p>
    <p>
      La presente Privacy Policy è conforme al Regolamento Generale sulla Protezione dei Dati 
      (GDPR - Regolamento UE 2016/679) e al D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018 
      (Codice Privacy italiano).
    </p>
    <p>
      Utilizzando i nostri Servizi, l'utente accetta le pratiche descritte in questa Privacy Policy. 
      Se non si è d'accordo con questa Privacy Policy, si prega di non utilizzare i nostri Servizi.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'IntroductionSection',
  components: {
    PrivacySection
  }
}
</script>

